export default __webpack_public_path__ + "static/12-14ed3d43ce51418b3fdc8af97e80cf5d.jpg";